export default [
  {
    name: 'comments',
    path: '/comments',
    component: () => import(/* webpackChunkName: "comments" */ './index.vue')
  }
]
